export const CHILD_SUPPORT_PAYMENTS_CONTAINER_TAG_NAME = 'child-support-payments-container';
